<template>
  <main>
    <PageIntro v-if="appLogin === false"
      :heading="'Register for a <span>' +configStrings.productName + '</span>'"
      :body="'<p>Enter your details below to create your ' +configStrings.productName + '.</p>'" />
    <PageIntro v-else
      :heading="'Register for a <span>' +configStrings.productName + '</span>'"
      :body="''" />
    <RegistrationFull />
    <FooterShout v-if="appLogin === false" :type="'signin'"/>
  </main>
</template>

<script>
  import RegistrationFull from '@/components/RegistrationFull'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      RegistrationFull,
      PageIntro,
      FooterShout
    },
    data() {
      return {
        appLogin: false
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-register'){
        this.appLogin = true
      }
    },
  }
</script>
